import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// import PIText from 'components/ProductIdentity/Text.jsx';

export const THEME_SELECTED_GREEN = 'selectedGreen';
export const THEME_SELECTED_GREY = 'selectedGrey';

const list = '/assets/new-design/images/icons/list.svg';
const pin = '/assets/new-design/images/icons/pin.svg';

const MapSwitch = React.forwardRef(
    ({ onClick, className, checked, label, disabled, theme, onChange }, ref) => {
        const handleChange = e => {
            if (onChange) {
                onChange(e);
            }
        };

        return (
            <div className={classNames('nd-map-switch-container', className, { [theme]: theme })}>
                <label className="nd-switch">
                    <input
                        ref={ref}
                        onChange={handleChange}
                        onClick={!disabled && onClick}
                        type="checkbox"
                        checked={checked}
                        readOnly
                        disabled={disabled}
                    />
                    <span className="nd-slider round"></span>
                    <div className="nd-switch-icons">
                        <img src={list} alt="list" />
                        <img src={pin} alt="pin" />
                    </div>
                </label>
            </div>
        );
    }
);
MapSwitch.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    checked: PropTypes.bool,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    theme: PropTypes.string,
    onChange: PropTypes.func,
};
MapSwitch.defaultProps = {
    disabled: false,
    theme: THEME_SELECTED_GREEN,
    onChange: () => null,
};
export default MapSwitch;
